// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../settings.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./norgie.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.SingleLineCollapsibleContainerLabel--collapsibleLabel--jwq_c {
}

.SingleLineCollapsibleContainerLabel--labelContainer--TH25a {
  cursor: pointer;
  display: flex;
  align-items: baseline;
}

.SingleLineCollapsibleContainerLabel--labelContainer--TH25a:hover {
  color: var(--text-hover);
}

.SingleLineCollapsibleContainerLabel--mainText--NGxZr {
}

.SingleLineCollapsibleContainerLabel--secondaryText--dE2hg {
}

@media print {

  .SingleLineCollapsibleContainerLabel--labelContainer--TH25a {
    align-items: flex-end;
  }

  .SingleLineCollapsibleContainerLabel--mainText--NGxZr {
  }

  .SingleLineCollapsibleContainerLabel--secondaryText--dE2hg {
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/settings/common/SingleLineCollapsibleContainerLabel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;AAEA;;AAEA;EAGE,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;;EAEE;IACE,qBAAqB;EACvB;;EAEA;EAEA;;EAEA;EAEA;;AAEF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.collapsibleLabel {\n  composes: settingsHeader from '../settings.css';\n}\n\n.labelContainer {\n  composes: defaultSize mediumContrastText from '../../../styles/typography.css';\n  composes: norgie from './norgie.css';\n  cursor: pointer;\n  display: flex;\n  align-items: baseline;\n}\n\n.labelContainer:hover {\n  color: var(--text-hover);\n}\n\n.mainText {\n  composes: boldText from '../../../styles/typography.css';\n}\n\n.secondaryText {\n  composes: secondaryText from '../settings.css';\n}\n\n@media print {\n\n  .labelContainer {\n    align-items: flex-end;\n  }\n\n  .mainText {\n    composes: mainHeaderText from '../settings.css';\n  }\n\n  .secondaryText {\n    composes: secondaryText from '../settings.css';\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsibleLabel": `SingleLineCollapsibleContainerLabel--collapsibleLabel--jwq_c ${___CSS_LOADER_ICSS_IMPORT_0___.locals["settingsHeader"]}`,
	"labelContainer": `SingleLineCollapsibleContainerLabel--labelContainer--TH25a ${___CSS_LOADER_ICSS_IMPORT_1___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_2___.locals["norgie"]}`,
	"mainText": `SingleLineCollapsibleContainerLabel--mainText--NGxZr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boldText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mainHeaderText"]}`,
	"secondaryText": `SingleLineCollapsibleContainerLabel--secondaryText--dE2hg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondaryText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondaryText"]}`
};
export default ___CSS_LOADER_EXPORT___;
